import { Redirect } from "react-router";
import { ScrollableView } from "@remo-co/ui-core/src/components/ScrollableView";
import useQueryParams from "modules/queryParams/hooks/useQueryParams";
import { TopBar } from "modules/topBar";
import { IEvent } from "modules/event/types";
import { ContactHost } from "modules/contactHost/components/ContactHost";
import { ContactHostOrigin } from "modules/contactHost/constants";
import { VideoAudioTestView } from "../VideoAudioTestView";
import { useStyles } from "./styles";
import { GeartestContext } from "../../types";

interface Props {
  loadedEvent: IEvent | null;
}

const MicCamCheckView = ({ loadedEvent }: Props): JSX.Element => {
  const { event: eventCode } = useQueryParams();
  const classes = useStyles();

  if (!eventCode) {
    return <Redirect to="/account-settings/cam-mic" />;
  }

  return (
    <>
      <div className={classes.topBarContainer}>
        <TopBar />
      </div>
      <ScrollableView style={{ overflowY: "auto" }} withAppBar>
        <div className={classes.micCamCheckContainer}>
          <VideoAudioTestView context={GeartestContext.preEvent} />
          <ContactHost
            origin={ContactHostOrigin.MIC_CAM_CHECK}
            event={loadedEvent}
            positionedAbsolute
          />
        </div>
      </ScrollableView>
    </>
  );
};

export default MicCamCheckView;
